import { FieldGuesser, ListGuesser } from '@api-platform/admin'
import React from 'react'
import {
    Create as BaseCreate,
    Edit as BaseEdit,
    required,
    SaveButton,
    SimpleForm,
    Toolbar,
    SelectInput,
    useRecordContext,
    ReferenceField,
    FunctionField,
} from 'react-admin'

const Title = () => {
    const record = useRecordContext()

    return <span>{record ? `${record?.title}` : ''}</span>
}

const EditToolbar = (props) => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
)

const InputFields = ({ Guesser, ...props }) => (
    <Guesser {...props}>
        <SimpleForm toolbar={<EditToolbar />}>
            <SelectInput
                fullWidth
                label='Status'
                source='status'
                choices={[
                    { id: 'Pending', name: 'Pending' },
                    { id: 'Accepted', name: 'Accepted' },
                    { id: 'Refused', name: 'Refused' },
                ]}
                validate={[required()]}
            />
        </SimpleForm>
    </Guesser>
)

const Fields = ({ Guesser, children, ...props }) => (
    <Guesser {...props}>
        <ReferenceField label='Owner' source='user' reference='users' sortable={false}>
            <FunctionField render={(record) => record.fullName} />
        </ReferenceField>
        <FieldGuesser label='Status' source='status' />
        {children}
    </Guesser>
)

export const Create = (props) => <InputFields Guesser={BaseCreate} title={`CREATE`} {...props} />

export const Edit = (props) => <InputFields Guesser={BaseEdit} title={<Title />} {...props} />

export const List = (props) => <Fields Guesser={ListGuesser} {...props} />

const CRUD = {
    list: List,
    edit: Edit,
}

export default CRUD
